import { FileServiceContextProvider } from './FileServiceContext';
import { SpeakerPanelContextProvider } from './SpeakerPanelContext';
import { TabContextProvider } from './TabsContext';
import { UserContextProvider } from './UserContext';
import { UserSettingsContextProvider } from './UserSettingsContext';
import { WorkspaceContextProvider } from './WorkspaceContext';

export const ContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <UserSettingsContextProvider>
    <UserContextProvider>
      <SpeakerPanelContextProvider>
        <TabContextProvider>
          <WorkspaceContextProvider>
            <FileServiceContextProvider>{children}</FileServiceContextProvider>
          </WorkspaceContextProvider>
        </TabContextProvider>
      </SpeakerPanelContextProvider>
    </UserContextProvider>
  </UserSettingsContextProvider>
);
